import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import type { Program } from '../../types/content';
import { site } from '../../data/site';
import { usePrograms } from '../../contexts/ProgramContext';
import { ButtonLink } from '../ui/ButtonLink';
interface ProgramCardProps {
  program: Program;
}
export function ProgramCard({
  program
}: ProgramCardProps) {
  const {
    setTrialChoice
  } = usePrograms();
  const isCompetition = program.id === 'competition-team';
  return <article id={`program-${program.id}`} aria-labelledby={`program-${program.id}-title`} className="flex h-full w-full scroll-mt-28 flex-col overflow-hidden rounded bg-white text-left ring-1 ring-line" data-id="element-199" data-mp="18putgy1o8zit">
      <div className="relative aspect-[16/10] w-full overflow-hidden bg-ink" data-id="element-200" data-mp="1hq9o4o0izqyz">
        <img src={program.image} alt={program.imageAlt} className="h-full w-full" style={{
        objectPosition: program.imagePosition,
        objectFit: program.imageFit ?? 'cover'
      }} loading="lazy" data-id="element-201" data-mp="2y4j3ismsi5do" />
        <span className="absolute left-3 top-3 rounded-sm bg-ink px-2.5 py-1 text-[13px] font-semibold text-white" data-id="element-202" data-mp="2w1seduhe217q">
          {program.audience}
        </span>
      </div>
      <div className="flex flex-1 flex-col p-6 lg:p-8" data-id="element-203" data-mp="352qn2q2ruwwn">
        <h3 id={`program-${program.id}-title`} className="font-display text-[2rem] font-bold uppercase leading-none lg:text-[2.25rem]" data-id="element-204" data-mp="35176szh48luv">
          {program.name}
        </h3>
        <p className="text-pretty mt-4 text-base leading-relaxed text-muted" data-id="element-205" data-mp="2cci3quwi26gh">{program.description}</p>

        <h4 className="mt-6 text-sm font-semibold uppercase tracking-[0.1em]" data-id="element-206" data-mp="2mcin2gudcmko">In class, students practice</h4>
        <ul className="mt-3 space-y-2.5" data-id="element-207" data-mp="2r2z225du8g95">
          {program.practices.map(practice => <li key={practice} className="flex items-start gap-3 text-[15px] leading-relaxed" data-id="element-208" data-mp="1tnv08gtz1p50">
              <span className="mt-[10px] h-[3px] w-4 shrink-0 bg-brand" aria-hidden="true" data-id="element-209" data-mp="1ymy1rraqtd88" />
              <span data-id="element-210" data-mp="1yklfj1xycgpd">{practice}</span>
            </li>)}
        </ul>

        <div className="mt-6 border-t border-line pt-5" data-id="element-211" data-mp="1qkf9dy05xt28">
          <h4 className="text-sm font-semibold" data-id="element-212" data-mp="1mlg9wsx7aoi6">A good fit for</h4>
          <p className="text-pretty mt-2 text-[15px] leading-relaxed text-muted" data-id="element-213" data-mp="20c1ucm2az6i6">{program.goodFit}</p>
        </div>

        <div className="mt-auto pt-6" data-id="element-214" data-mp="1vcgl9itf5hrq">
          <ButtonLink href={isCompetition ? `${site.emailHref}?subject=${encodeURIComponent('Competition Team inquiry')}` : '#first-class'} onClick={() => {
          if (!isCompetition) setTrialChoice(program.id);
        }} className="w-full !whitespace-normal py-3 text-center leading-snug md:w-fit" icon={<ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-216" data-mp="1cmqud6ss1g53" />} data-id="element-215" data-mp="1vdi9yq3cy2rx">
            {program.ctaLabel}
          </ButtonLink>
        </div>
      </div>
    </article>;
}